/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'

export default function Newearth(props) {
  const { nodes, materials } = useGLTF('/reglobe.glb')

  const groupref = useRef()

  useFrame(() => {
    groupref.current.rotation.y += 0.001
  })

  return (
    <group {...props} position={[0,0,0]} dispose={null} ref={groupref} scale={[6,6,6]}>
      <mesh
        name="Cube"
        castShadow
        receiveShadow
        geometry={nodes.Cube.geometry}
        material={materials.Material_0}
        rotation={[-1.833, 1.309, -1.745]}
        scale={0.004}
      />
      <mesh
        name="Cube001"
        castShadow
        receiveShadow
        geometry={nodes.Cube001.geometry}
        material={materials.Material_0}
        rotation={[-2.322, 0.365, -0.619]}
        scale={0.004}
      />
      <mesh
        name="Cube002"
        castShadow
        receiveShadow
        geometry={nodes.Cube002.geometry}
        material={materials.Material_0}
        rotation={[0, Math.PI / 3, 0]}
        scale={0.004}
      />
      <mesh
        name="Cube003"
        castShadow
        receiveShadow
        geometry={nodes.Cube003.geometry}
        material={materials.Material_0}
        rotation={[-0.986, -0.695, -0.696]}
        scale={0.004}
      />
      <mesh
        name="Cube004"
        castShadow
        receiveShadow
        geometry={nodes.Cube004.geometry}
        material={materials.Material_0}
        rotation={[0, -0.436, 0]}
        scale={0.004}
      />
      <mesh
        name="Sphere"
        castShadow
        receiveShadow
        geometry={nodes.Sphere.geometry}
        material={materials.Material_1}
        scale={0.004}
      />
    </group>
  )
}

useGLTF.preload('/reglobe.glb')
